// extracted by mini-css-extract-plugin
export default {"container":"Cookie_container__hpLlC","containerHiding":"Cookie_containerHiding__P6da1","hiding":"Cookie_hiding__Um8YJ","ok":"Cookie_ok__CKXEU","text":"Cookie_text__llHhZ"};